import React from 'react';

import { Box } from '@chakra-ui/react';
import { Notifications, SettingsSchedule, Task } from '@mesh.ai/rabbit';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { IconSteps, StepCard } from '../commonComponents';

const GuideSection = () => (
  <StepCard title="On Mesh you'll get notified of the following">
    <Box>
      <IconSteps
        steps={[
          {
            iconSvg: Notifications,
            stepComp: (
              <TextBodyMedium>Receive updates for any progress in a Mesh pod on a Slack channel</TextBodyMedium>
            ),
          },
          {
            iconSvg: SettingsSchedule,
            stepComp: <TextBodyMedium>Choose summary updates that you wish to receive daily/weekly</TextBodyMedium>,
          },
          {
            iconSvg: Task,
            stepComp: <TextBodyMedium>Know your pending tasks directly from Slack</TextBodyMedium>,
          },
        ]}
      />
    </Box>
  </StepCard>
);

export { GuideSection };
